import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deletePoAttachmentQuery = (data) => {
  const { docId, attachmentId } = data || {};
  const id = docId ?? attachmentId;
  if (!id) return Promise.reject(new Error('docId or attachmentId is required'));
  const url = `${apiurl?.deletePoAttachment}?docId=${encodeURIComponent(id)}`;
  return axios.delete(url);
};

const deletePoAttachment = () => {
  const queryClient = useQueryClient();
  return useMutation(deletePoAttachmentQuery, {
    onSuccess: (_, variables) => {
      const poId = variables?.purchaseOrderId;
      const arqId = variables?.arqId ?? null;
      if (poId) {
        // Invalidate only this context (PO or ARQ) so ARQ deletes don't refetch PO attachments
        queryClient.invalidateQueries(['getPoAttachments', poId, arqId]);
      }
    }
  });
};

export default deletePoAttachment;
